import styled_components from "styled-components";
const RatingDivider = /*#__PURE__*/ styled_components.hr.withConfig({
    displayName: "Ratings.styles__RatingDivider"
})([
    "width:1px;height:16px;background-color:rgba(0,24,51,1);margin:0px 8px;border:0px;"
]);
export { RatingDivider };
